import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './views/Dashboard';
import PaymentDone from './views/PaymentDone';
import OnlineDashboard from './views/OnlineDashboard';
import OnlinePaymentDone from './views/OnlinePaymentDone';
import Login from './views/Login';


Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/p/:token?',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/d/:token?',
      name: 'PaymentDone',
      component: PaymentDone
    },
    {
      path: '/o/:token?',
      name: 'OnlineDashboard',
      component: OnlineDashboard
    }, {
      path: '/do/:token?',
      name: 'OnlinePaymentDone',
      component: OnlinePaymentDone
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
  ]
})
